import {Injectable} from '@angular/core';
import {OidcSecurityService} from 'angular-auth-oidc-client';

@Injectable({
  providedIn: 'root'
})
export class SsoUserService {

  public isAuthenticated: boolean;
  public idToken = '';
  public accessToken = '';

  constructor(private oidcSecurityService: OidcSecurityService) {
    this.oidcSecurityService.isAuthenticated$.subscribe(res => {
      this.isAuthenticated = res.isAuthenticated;
      this.initTokens();
    });

    this.initTokens();
  }

  initTokens() {
    this.oidcSecurityService.getIdToken()
      .subscribe(res => {
        this.idToken = res;
        this.isAuthenticated = this.idToken !== '';
      });
    this.oidcSecurityService.getAccessToken()
      .subscribe(res => {
        this.accessToken = res;
      });
  }
}
